export default __webpack_public_path__ + "assets/webgl/complete-13.97e9651e.jpg";